export default [{
  path: '/checklists-honorarios',
  component: {
    name: 'ChecklistHonorariosBase',
    template: '<router-view />',
    meta: {
      resource: 'parametrizacaochecklist',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'checklists-honorarios',
    component: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/ChecklistHonorariosView.vue'),
    meta: {
      resource: 'parametrizacaochecklist',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'checklists-honorarios',
      pageTitle: 'Parametrizações de checklist',
      breadcrumb: [
        {
          text: 'Parametrizações de checklist',
          to: { name: 'checklists-honorarios' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-checklist-honorarios',
    component: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/components/cadastro-parametrizacao/ChecklistHonorarios.vue'),
    meta: {
      resource: 'parametrizacaochecklist',
      action: 'create',
      requiredAuth: true,
      navActiveLink: 'checklists-honorarios',
      pageTitle: 'Parametrizações de checklist',
      breadcrumb: [
        {
          text: 'Parametrizações de checklist',
          to: { name: 'checklists-honorarios' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-checklist-honorarios' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-checklist-honorarios',
    component: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/components/cadastro-parametrizacao/ChecklistHonorarios.vue'),
    meta: {
      resource: 'parametrizacaochecklist',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'checklists-honorarios',
      pageTitle: 'Parametrizações de checklist',
      breadcrumb: [
        {
          text: 'Parametrizações de checklist',
          to: { name: 'checklists-honorarios' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-checklist-honorarios' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'copiar/:copia/copiaId/:id',
    name: 'copiar-checklist-honorarios',
    component: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/components/cadastro-parametrizacao/ChecklistHonorarios.vue'),
    meta: {
      resource: 'parametrizacaochecklist',
      action: 'create',
      navActiveLink: 'checklists-honorarios',
      pageTitle: 'Parametrizações de checklist',
      breadcrumb: [
        {
          text: 'Parametrizações de checklist',
          to: { name: 'checklists-honorarios' },
        },
        {
          text: 'Copiar',
          to: { name: 'copiar-checklist-honorarios' },
          active: true,
        },
      ],
    },
  }],
},
]
